const projectOrder = [
  "project-agent",
  "project-dnnd",
  "project-rag",
  "project-9",
  "project-automotive-seg",
  "project-etl-integration",
  "project-churn",
  "project-6",
  "project-10",
  "project-8",
  "project-7",
  "project-1",
];

export default projectOrder;
